import useResizeObserver from '@react-hook/resize-observer';
import { RefObject, useLayoutEffect, useState } from 'react';

export const useElementSize = (target: RefObject<HTMLElement>, disabled?: boolean) => {
  const [elementSize, setElementSize] = useState({ height: 0, width: 0 });

  useLayoutEffect(() => {
    if (!target || disabled) {
      return;
    }
    const { current } = target;
    if (!current) {
      return;
    }

    setElementSize(current.getBoundingClientRect());
  }, [disabled, target]);

  // Where the magic happens
  useResizeObserver(!disabled ? target : null, (entry) => setElementSize(entry.contentRect));

  if (disabled) {
    return { height: 0, width: 0 };
  }

  return elementSize;
};
